import { IPromotionParams } from 'core/model/interfaces/promotions';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { SLICE_NAMESPACE } from '../constants';
import type { IPromotionsState } from '../types';

export const fetchPromotionList = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchPromotionList`,
  async (params: IPromotionParams, { getState }) => {
    const { promotions } = getState();
    return apiService.promotions.getPromotionList({
      ...params,
      page: promotions.promotionList.pagination.currentPage,
    });
  },
);

export const fetchPromotionListReducer: TSliceExtraReducer<IPromotionsState> = builder =>
  builder
    .addCase(fetchPromotionList.pending, state => {
      state.promotionList.isLoading = true;
    })
    .addCase(fetchPromotionList.rejected, state => {
      state.promotionList.isLoading = false;
      state.promotionList.data = [];
    })
    .addCase(fetchPromotionList.fulfilled, (state, { payload }) => {
      state.promotionList.data = payload.promotions;
      state.promotionList.pagination = payload.pagination;
      state.promotionList.isLoading = false;
    });
